import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { GdsBaggageAndVipServiceType, GdsServiceLimitInfo, GdsServicesCalculatedLimitInfo } from '../../../../types';

export function getGdsServiceCalculatedCountInfo(
	passengerId: string,
	segmentId: string,
	servicesCalculatedLimitInfo: GdsServicesCalculatedLimitInfo,
	params: {
		rfisc?: string;
		subType?: GdsBaggageAndVipServiceType;
		type?: OrderAdditionalServiceGdsServiceServiceType;
	}
): GdsServiceLimitInfo | undefined {
	const calculatedCountInfo = servicesCalculatedLimitInfo[passengerId]?.[segmentId];
	if (!calculatedCountInfo) {
		return undefined;
	}

	const { rfisc, subType, type } = params;

	if (rfisc) {
		const byRfisc = calculatedCountInfo.rfisc?.[rfisc];
		if (byRfisc) {
			return byRfisc;
		}
	}

	if (subType) {
		const bySubType = calculatedCountInfo.subType?.[subType];
		if (bySubType) {
			return bySubType;
		}
	}

	if (type) {
		const byType = calculatedCountInfo.type?.[type];
		if (byType) {
			return byType;
		}
	}

	return undefined;
}
